import { createSelector } from '@ngrx/store'

import { ProcessState } from './../reducers/process.reducer'

export const processes = (state): ProcessState => state.equipmentState.process

export const process = createSelector(processes, processList => processList.process)
export const configuration = createSelector(processes, processList => processList.configuration)
